export const GOOGLE_TAG_MANAGER_KEY =
  process.env.GATSBY_GOOGLE_TAG_MANAGER_KEY || 'GTM-KMH3BRH'

export const PAGE_INTERNAL_URL = process.env.GATSBY_LANDING_INTERNAL_URL
export const BLOG_URL = process.env.GATSBY_BLOG_URL
export const JOB_PLATFORM_URL = process.env.GATSBY_JOB_PLATFORM_URL
export const BOOKING_PLATFORM_URL = process.env.GATSBY_BOOKING_PLATFORM_URL
export const COOKIE_PRO_ID = process.env.GATSBY_COOKIE_PRO_ID
